<template>
  <section id="deployment" ref="deploymentContent">
    <PageTitle :title="$t('cms.deployment.title')" :breadcrumbs="breadcrumbs"></PageTitle>
    
    <div class="wrapper wrapper-content animated fadeInRight">

      <Header></Header>

      <div class="row" v-if="selectedSite">
        <div class="col">
          <Validation></Validation>
        </div>
      </div>

      <div class="row" v-if="selectedSite && selectedSite.options.isSiteDeploymentAllowed">
        <div class="col">
          <Site></Site>
        </div>
      </div>

      <!--
      <div class="row" v-if="siteOptions.isCustomizationDeploymentAllowed">
        <div class="col">
          <Theme :site="site" :productionSite="productionSite"></Theme>
        </div>
      </div>  
      -->

    </div>
  </section>
</template>


<script lang="ts">
import { Component } from '@fwk-node-modules/vue-property-decorator';
import { mixins } from '@fwk-node-modules/vue-class-component';
import GenericPage from '@fwk-client/components/mixins/GenericPage.vue';

import PageTitle from '@root/src/client/components/panels/PageTitle.vue';
import { enableIbox, disableIbox} from '@root/src/client/theme/inspinia-jquery'; 

import { useSiteAdmin } from '../../composables/useSiteAdmin';

import Validation from '../panels/deployment/Validation.vue';
import Theme from '../panels/deployment/Theme.vue';
import Site from '../panels/deployment/Site.vue';
import Header from '../panels/Header.vue';

@Component({
  components: {
    PageTitle,
    Validation,
    Theme,
    Header,
    Site
  }
})
export default class Deployment extends mixins(GenericPage) {

  setup(props:any, context:any) {
    const { sites, selectedSite } = useSiteAdmin(props, context);
    return { sites, selectedSite }
  }

  get breadcrumbs() {
    return [{
      label: this.$t('home.dashboard')
    },
    {
      label: this.$t('cms.title')
    }]
  }

  mounted() {
    enableIbox(this.$refs.deploymentContent as HTMLElement);
  }

  beforeDestroy() {
    disableIbox(this.$refs.deploymentContent as HTMLElement);
  }

}
</script>